import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Redirector: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "F12") {
        e.preventDefault(); // Optional: prevent browser devtools from opening
        navigate("/items");
      }
      if (e.key === "F11") {
        e.preventDefault(); // Optional: prevent browser devtools from opening
        navigate("/partners");
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [navigate]);

  return null; // It doesn’t render anything
};

export default Redirector;
